import React from 'react';
import NotFound from '../../../../components/not_found_component/not_found_component';
import PropTypes from 'prop-types';

export default function Error({ statusCode }) {
  return (
    <section className="tag-page">
      <article className="tag-page__main--error-pg">
        <NotFound statusCode={statusCode} />
      </article>
    </section>
  );
}

Error.propTypes = {
  statusCode: PropTypes.number
};

Error.defaultProps = {
  statusCode: 404
};
